import React, { ReactNode } from 'react';
import cn from 'classnames';

import { useModal } from '@components/common/Modal/utils';

import { IConfirmProps } from './Confirm.types';

import Button from '../Button';
import SpinnerOverlay from '../SpinnerOverlay';

import './Confirm.scss';

const Confirm: React.FC<IConfirmProps> = ({
	onClose,
	onSubmit,
	onProceed,
	question,
	children,
	isLoading,
	positiveBtnText = 'Yes',
	negativeBtnText = 'No',
	proceedBtnText = 'Proceed',
	containerClassName,
}) => {
	const { onClose: closeModal } = useModal();

	const handleCloseModal = onClose ? onClose : closeModal;

		const descriptionClassName = cn({
			'f5gConfirmDescription': !!question,
		});

	return (
		<div className={cn('f5gConfirmContainer', containerClassName)}>
			{isLoading && <SpinnerOverlay />}
			<div>
				{question}
			</div>
			{children &&
				<div className={descriptionClassName}>
					{children as ReactNode}
				</div>
			}
			<div className='f5gConfirmActions'>
				<Button
					disabled={isLoading}
					large
					onClick={handleCloseModal}
					text={negativeBtnText}
					withoutBackground
				/>
				{onProceed && (
					<Button
						disabled={isLoading}
						large
						onClick={onProceed}
						secondary
						text={proceedBtnText}
					/>
				)}
				{onSubmit && (
					<Button
						disabled={isLoading}
						large
						onClick={onSubmit}
						text={positiveBtnText}
					/>
				)
				}
			</div>
		</div>
	);
};

export default Confirm;
